export const eventCat = 'Modules';
export const eventName = 'eventTracker';
export const eventAct = '';

// convert array of obj to obj:
// {
// 	key: analyticObj
// }
export const convertToAnalyticObject = store => {
  store.forEach(analytic => {
    analytic.eventCat = analytic.eventCat && analytic.eventCat !== '' ? analytic.eventCat : eventCat;
    analytic.eventAct = analytic.eventAct && analytic.eventAct !== '' ? analytic.eventAct : eventAct;
    analytic.eventName = analytic.eventName && analytic.eventName !== '' ? analytic.eventName : eventName;
  });
  store = store.reduce((obj, item) => Object.assign(obj, {
    [item.key]: item
  }), {});
  return store;
};
export const addDefaultValues = analytic => {
  if (analytic) {
    analytic.eventCat = analytic.eventCat ? analytic.eventCat : eventCat;
    analytic.eventName = analytic.eventName ? analytic.eventName : eventName;
  }
  return analytic;
};